import { ISmartScheduleShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ShiftEditorViewStateSchema } from "..";

export default mutatorAction("setSmartScheduleShiftInStore", function setSmartScheduleShiftInStore(
    store: ShiftEditorViewStateSchema,
    smartScheduleShift: ISmartScheduleShiftEntity
) {
    if (store) {
        store.smartScheduleShift = smartScheduleShift;
    }
});
